import { useState, useEffect } from "react"

import { Box, Stack } from "@mui/material"
import { markerDataFromEvents, remapRawServerEvents } from "@/common/utils"
import GoogleMapComponent from "@/components/mapBox/GoogleMapComponent"
import { useJsApiLoader } from "@react-google-maps/api"
import useGetMapEvents from "@/hooks/api/events/useGetMapEvents"
import { useEventContext } from "@/contexts/EventContext"
import { useQueryClient } from "@tanstack/react-query"
import queryKeys from "@/api/queryKeys"
import { RawServerEvent } from "@/common/types"
import { useLocation } from "react-router-dom"

type MarkerData = {
  position: google.maps.LatLngLiteral
  icon?: string
  label?: string
  info?: string
  image?: string
}

const libraries: ["places"] = ["places"]

const MobileMapComponent = () => {
  const [markerData, setMarkerData] = useState([] as MarkerData[])
  const queryClient = useQueryClient()
  const location = useLocation()
  const [bounds, setBounds] = useState<{
    north: number
    south: number
    east: number
    west: number
  }>({
    north: 32.9,
    south: 32.6,
    east: -79.8,
    west: -80.1,
  })

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAP_KEY, // Make sure this is set correctly
    libraries,
  })

  const { value, searchVal, ageRangeFilter, petFriendlyFilter, priceFilter } =
    useEventContext()
  const { data: eventResponse, isSuccess } = useGetMapEvents({
    filters: {
      filter: value,
      searchValue: searchVal,
      ageRange: ageRangeFilter,
      petFriendly: petFriendlyFilter,
      price: priceFilter,
      bounds,
    },
  })

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.events.mapPage({
        filter: value,
        searchValue: searchVal,
        ageRange: ageRangeFilter,
        petFriendly: petFriendlyFilter,
        price: priceFilter,
      }).queryKey,
    })
    if (isSuccess && eventResponse) {
      setMarkerData(
        markerDataFromEvents(
          remapRawServerEvents(eventResponse.events as RawServerEvent[])
        )
      )
    }
  }, [
    queryClient,
    searchVal,
    value,
    petFriendlyFilter,
    priceFilter,
    ageRangeFilter,
    eventResponse,
    isSuccess,
  ])

  return (
    <>
      <section style={{ backgroundColor: "#1A2958", overflow: "hidden" }}>
        <Box>
          <Stack
            direction="row"
            sx={{ width: "100%", justifyContent: "center" }}
          >
            <Box
              style={{
                height: "82vh",
                width: "100%",
                maxWidth: "100%",
                overflow: "hidden",
              }}
            >
              {!isLoaded ? (
                <div>Loading...</div>
              ) : (
                <GoogleMapComponent
                  markerData={markerData}
                  location={location}
                  setBounds={setBounds}
                  activeFilters={value}
                />
              )}
            </Box>
          </Stack>
        </Box>
      </section>
    </>
  )
}

export default MobileMapComponent
